import { defaultThemeColors } from "@src/app/styles/themes/default"
import { themeKey, THEMES } from "@src/app/styles/themes/theme"
import { transfarioThemeColors } from "@src/app/styles/themes/trransfario"

export function setTheme() {
  const VARS_MAP = {
    [THEMES.CRYPTIX]: defaultThemeColors,
    [THEMES.TRANSFERIO]: transfarioThemeColors,
  }

  const vars = VARS_MAP[themeKey]

  Object.entries(vars).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value)
  })
}
